import React from "react";
import "./Error.scss";
const Error = ({ children }) => {
    return <div className="error-wrapper">{children}</div>;
};

export default Error;
